















































































































import LeftMenu from '@/components/menus/LeftMenu.vue'
import MenuItem from '@/models/menu-item.model'
import { Component, Vue, Prop } from 'vue-property-decorator'
import authDecode from 'jwt-decode'

@Component({
    components: {
        LeftMenu
    }
})
export default class Admin extends Vue {
    @Prop(String) source!: string

    dialog = false
    drawer = false
    items: MenuItem[] = []

    loading = false

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    get pathList (): object[] {
        const route: string = this.$route.path
        let routes: string[]|object[] = route.split('/').filter(r => r !== '')
        routes = routes.map(route => route.charAt(0).toUpperCase() + route.substring(1))
        return routes.map(route => { return { text: route } })
    }

    async mounted () {
        if (window.innerWidth < 1264) {
            this.drawer = false
        }
        await this.parseDataFromAPI()
        // await this.adoptFair()
        // await this.deleteClonedChildren()
    }

    async parseDataFromAPI () {
        return new Promise(resolve => {
            this.loading = true

            const token = this?.$store?.state?.AuthStore?.auth._token

            if (!token) return

            const auth = authDecode(token)
            auth.exp = new Date(auth.exp * 1000)

            if (auth.exp.getTime() - new Date().getTime() <= 0) return

            if (!this.$store?.state?.AuthStore?.auth?.user?.userId) return

            this.$store.dispatch('getMenuUser')
                .then(resp => {
                    if (resp?.status === 200) {
                        if (resp.data?.menuItems) {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            resp.data.menuItems.forEach((item: any) => {
                                const newItem = new MenuItem({
                                    id: item.menuItemId,
                                    url: item.menuItemUrl,
                                    icon: item.menuItemIcon || null,
                                    iconAlt: item.menuItemIconAlt || null,
                                    text: item.menuItemTitle,
                                    model: false,
                                    menuItemParentId: item.menuItemParentId || null,
                                    routeParams: item.routeParams || null,
                                    children: item.children
                                })

                                this.items.push(newItem)
                            })
                        }
                    } else {
                        this.$store.commit('reportError', { code: 1000, message: 'Couldn\'t Find Menu' })
                    }
                    this.loading = false
                    resolve()
                })
        })
    }

    // adoptFair () {
    //     return new Promise(resolve => {
    //         this.items.forEach((item: MenuItem) => {
    //             if (item.parentItem !== null) {
    //                 const parent = this.items.find((localItem: MenuItem) => localItem.id === item.parentItem?.id)
    //                 if (parent) {
    //                     if (!parent.children) parent.children = []
    //                     parent.children.push(item)
    //                 } else {
    //                     this.$store.commit('reportError', { code: 1000, message: `Couldn't Find Parent for ${JSON.stringify(item)} :(` })
    //                 }
    //             }
    //         })
    //         resolve()
    //     })
    // }

    // deleteClonedChildren () {
    //     return new Promise(resolve => {
    //         this.items = this.items.filter((item: MenuItem) => item.parentItem === null)
    //         resolve()
    //     })
    // }

    goProfile () {
        if (this.$route.path !== '/profile') {
            this.$router.push({ name: 'Profile' })
        }
    }

    logout () {
        localStorage.setItem('auth', '')
        localStorage.setItem('permissions', '')
        this.$store.commit('updateAuth', null)
        this.$router.push({ name: 'Login' })
    }
}
